import { IFiscoEvento } from "../interfaces/IFiscoEvento";
import api from "./Api";

class FiscoEventoService {
    async excluir(fiscoID: number, eventoID:number): Promise<void> {
        await api.delete(`FiscoEvento/${fiscoID}/${eventoID}`);
    }

    async criar(fisco:IFiscoEvento): Promise<void> {
        await api.post('FiscoEvento', fisco);
    }
    
    async obterPorId(fiscoID: number): Promise<IFiscoEvento[]>{
        let {data: fisco} = await api.get<IFiscoEvento[]>(`FiscoEvento/${fiscoID}`);

        return fisco;
    }
}


export default new FiscoEventoService();